import React, { useEffect, useRef, useState } from "react";
import {
  PencilSquareIcon,
  ClipboardDocumentIcon,
} from "@heroicons/react/24/solid";
import { MdDelete } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import { Modal } from "../../../components";
import { ToastContainer, toast } from "react-toastify";
import { gridClasses } from "@mui/x-data-grid-pro";
import "react-toastify/dist/ReactToastify.css";
import api from "../../../services/api";
import AddUpdateForm from "./AddUpdateForm";
import Loading from "../../../components/Loader/Loading";
import MUIDataTable from "../../../components/MUIGrid";
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid-pro";
import { Button as MUIButton, TablePagination } from "@mui/material";
import CustomBreadcrumbs from "../../../components/common/CustomBreadcrumbs";
import { Dropdown } from "primereact/dropdown";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import UpdateReason from "./UpdateReason";
import dayjs from "dayjs";
export default function DomainOutreachReport() {
  const [records, setRecords] = useState([]);
  const [users, setUsers] = useState([]);
  const [isReasonModal, setReasonModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isTaskStatus, setTaskStatus] = useState({});
  const [errors, setErrors] = useState({});
  const [isStatusNote, setStatusNote] = useState("");
  const [isHoldReason, setHoldReason] = useState("");
  const handleCopyContent = (content, type = "") => {
    navigator.clipboard.writeText(content);
    toast.success(`${type ? type + " " : ""}Copied to clipboard!`);
  };
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 100,
    page: 1,
  });
  const [queryOptions, setQueryOptions] = React.useState({
    groupOp: "",
    rules: [],
  });

  const taskStatusOptions = [
    { value: "pending", label: "Pending" },
    { value: "inProcess", label: "In Process" },
    { value: "inReview", label: "In Review" },
    { value: "hold", label: "Hold" },
    { value: "cancelled", label: "Cancelled" },
    { value: "completed", label: "Completed" },
    { value: "reOpen", label: "Reopen" },
  ];
  const get_listing = async (payload) => {
    if (!payload.loaderTerminated) {
      setIsLoading(true);
    }
    const { page, pageSize, filters } = payload;
    delete payload?.loaderTerminated;

    try {
      const res = await api.post("/api/domains/out_reach/list", {
        page,
        pageSize,
        ...payload,
        ...(filters?.rules?.length ? { filters: modifyRules(filters) } : {}),
      });
      if (res.status === 200 || res.status === 201) {
        setRecords(res.data);
      }
    } catch (err) {
      console.log(err);
    }

    if (!filters.loaderTerminated) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    Promise.all([
      get_listing({
        ...paginationModel,
        pageSize: paginationModel.pageSize,
        filters: queryOptions,
        loaderTerminated: true,
      }),
      get_user(),
    ])
      .catch((error) => {
        console.error("Error in API calls:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function modifyRules(query) {
    if (!query.rules?.length) return query;
    query.rules = query.rules?.flatMap((rule) => {
      if (rule.field === "dor.created_at" && rule.op === "eq") {
        const dateStr = rule.data.replace(/'/g, ""); // Remove single quotes
        const date = new Date(dateStr);

        const startOfDay = new Date(date);
        startOfDay.setHours(0, 0, 0, 0);
        const startISO = startOfDay.toISOString(); // "2025-02-19T19:00:00.000Z"

        const endOfDay = new Date(date);
        endOfDay.setHours(23, 59, 59, 999);
        const endISO = endOfDay.toISOString(); // "2025-02-20T18:59:59.999Z"

        return [
          { field: "dor.created_at", op: "gte", data: `'${startISO}'` },
          { field: "dor.created_at", op: "lte", data: `'${endISO}'` },
        ];
      }
      if (rule.field === "dor.verified_at" && rule.op === "eq") {
        const dateStr = rule.data.replace(/'/g, ""); // Remove single quotes
        const date = new Date(dateStr);

        const startOfDay = new Date(date);
        startOfDay.setHours(0, 0, 0, 0);
        const startISO = startOfDay.toISOString(); // "2025-02-19T19:00:00.000Z"

        const endOfDay = new Date(date);
        endOfDay.setHours(23, 59, 59, 999);
        const endISO = endOfDay.toISOString(); // "2025-02-20T18:59:59.999Z"

        return [
          { field: "dor.verified_at", op: "gte", data: `'${startISO}'` },
          { field: "dor.verified_at", op: "lte", data: `'${endISO}'` },
        ];
      }
      return rule;
    });

    return query;
  }

  // Function to update status
  const updateStatus = async (record, newStatus, currentStatus) => {
    // Get the status labels for display
    const getStatusLabel = (status) => {
      const statusMap = {
        pending: "Pending",
        inProcess: "In Process",
        inReview: "In Review",
        hold: "On Hold",
        cancelled: "Cancelled",
        completed: "Completed",
        reOpen: "Reopened",
      };
      return statusMap[status] || status;
    };

    // Show confirmation dialog
    const confirmMessage = `Are you sure you want to change the status from "${getStatusLabel(
      currentStatus
    )}" to "${getStatusLabel(newStatus)}"?`;

    if (!window.confirm(confirmMessage)) {
      return;
    }

    const statusRequiresReason = [
      "inReview",
      "inProcess",
      "cancelled",
      "reOpen",
    ].includes(newStatus);
    setStatusNote(record?.["dor.note"]);
    if (statusRequiresReason) {
      setTaskStatus((prev) => ({
        ...prev,
        record,
        status: newStatus,
        currentStatus,
      }));
      setReasonModal(true);
      return;
    }
    await performStatusUpdate(record, newStatus, record?.["dor.note"]);
  };

  // Function to handle the actual status update
  const performStatusUpdate = async (record, status, note = "") => {
    setIsLoading(true);
    const taskErrors = {};
    const statusRequiresNote = [
      "inReview",
      "inProcess",
      "cancelled",
      "reOpen",
    ].includes(status);

    if (statusRequiresNote && note.trim() === "") {
      taskErrors.note_status = "Please enter a note.";
      setErrors(taskErrors);
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const response = await api.put(
        `/api/domains/out_reach/status/${record?.["dor.id"]}`,
        {
          status,
          note,
        }
      );

      if (response.status === 200 || response.status === 201) {
        toast.success(response?.data?.message || "Status updated successfully");
        setTaskStatus({});
        setStatusNote("");
        setReasonModal(false);
        get_listing({
          ...paginationModel,
          pageSize: paginationModel.pageSize,
          filters: queryOptions,
        });
      } else {
        toast.error(response?.data?.message || "Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error(error.response?.data?.message || "Failed to update status");
    } finally {
      setIsLoading(false);
    }
  };

  const get_user = async () => {
    try {
      const res = await api.post("/api/users/users_report", {
        page: 1,
        perPage: 1000,
      });
      if (res.status === 200) {
        setUsers(res.data?.records);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const [modalState, setModalState] = useState({
    open: false,
    data: null,
  });

  const cancelButtonRef = useRef(null);

  const handleModal = (data = null) => {
    setModalState((prev) => ({
      open: !prev.open,
      data: data,
    }));
  };

  const handleNewReport = () => {
    handleModal(null);
  };

  const handleEditReport = (record) => {
    handleModal(record);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPaginationModel({ ...paginationModel, pageSize: newPageSize });
  };
  const handlePageChange = (params) => {
    setPaginationModel({ pageSize: params.pageSize, page: params.page + 1 });
    get_listing({
      filters: queryOptions,
      page: +params.page + 1,
      pageSize: params.pageSize,
    });
  };
  const onFilterChange = React.useCallback((filterModel) => {
    let ruless = [];
    if (filterModel?.items?.length === 0) {
      get_listing({
        filters: queryOptions,
        page: 1,
        pageSize: paginationModel.pageSize,
      });
    }
    const timeZoneOffset = new Date().getTimezoneOffset();
    const dynamicOffset =
      (timeZoneOffset > 0 ? "-" : "+") +
      String(Math.abs(timeZoneOffset) / 60).padStart(2, "0") +
      ":" +
      String(Math.abs(timeZoneOffset) % 60).padStart(2, "0");
    // eslint-disable-next-line array-callback-return
    filterModel.items?.map((rule) => {
      ruless = [
        ...ruless,
        {
          field: `${rule.field}`,
          op:
            rule.operator === "contains"
              ? "cn"
              : rule.operator === "equals"
              ? "eq"
              : rule.operator === "is"
              ? "eq"
              : rule.operator === "="
              ? "eq"
              : rule.operator === "!="
              ? "not"
              : rule.operator === ">"
              ? "gt"
              : rule.operator === ">="
              ? "gte"
              : rule.operator === "<"
              ? "lt"
              : rule.operator === "<="
              ? "lte"
              : rule.operator,
          data: rule.value
            ? ["dor.verified_at", "dor.created_at"].includes(rule.field)
              ? `'${dayjs(rule.value)
                  .utcOffset(dynamicOffset)
                  .format("YYYY-MM-DDTHH:mm:ssZ")}'`
              : rule.value
            : null,
        },
      ];
    });
    setQueryOptions({
      groupOp: filterModel.logicOperator.toUpperCase(),
      rules: ruless,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNewFilter = () => {
    setPaginationModel({ pageSize: paginationModel.pageSize, page: 1 });
    get_listing({
      filters: queryOptions,
      page: 1,
      pageSize: paginationModel.pageSize,
    });
  };
  const handleTopPageChange = (page) => {
    setPaginationModel({ pageSize: paginationModel.pageSize, page: +page + 1 });
    get_listing({
      filters: queryOptions,
      page: +page + 1,
      pageSize: paginationModel.pageSize,
    });
  };
  const handleTopPageSizeChange = (newPageSize) => {
    setPaginationModel({ page: 1, pageSize: newPageSize });
    get_listing({
      filters: queryOptions,
      page: 1,
      pageSize: newPageSize,
    });
  };
  function CustomToolbar({ setFilterButtonEl }) {
    return (
      <GridToolbarContainer className="flex items-center justify-between">
        <div className="flex">
          <GridToolbarColumnsButton
            sx={{
              borderRadius: "6px",
              marginRight: "4px",
              border: "1px solid",
              borderColor: "#e8eaee",
              height: "26px",
              paddingLeft: 1,
              paddingRight: 1,
            }}
          />
          <GridToolbarDensitySelector
            sx={{
              borderRadius: "6px",
              marginRight: "4px",
              border: "1px solid",
              borderColor: "#e8eaee",
              height: "26px",
              paddingLeft: 1,
              paddingRight: 1,
            }}
          />
          <GridToolbarFilterButton
            sx={{
              borderRadius: "6px",
              marginRight: "4px",
              border: "1px solid",
              borderColor: "#e8eaee",
              height: "26px",
              paddingLeft: 1,
              paddingRight: 1,
            }}
            ref={setFilterButtonEl}
          />
          <MUIButton
            variant="text"
            onClick={handleNewFilter}
            startIcon={<FaSearch size={16} />}
            sx={{
              borderRadius: "6px",
              marginRight: "4px",
              border: "1px solid",
              borderColor: "#e8eaee",
              height: "26px",
              paddingLeft: 1,
              paddingRight: 1,
            }}
          >
            Apply filter
          </MUIButton>
        </div>
        <div className="flex items-center">
          <TablePagination
            color="primary"
            shape="rounded"
            size="medium"
            showFirstButton
            showLastButton
            count={
              records?.totalCount ? records?.totalCount : records?.length || 0
            }
            page={paginationModel.page - 1 || 0}
            onPageChange={(e, page) => handleTopPageChange(page)}
            rowsPerPage={paginationModel.pageSize || 100}
            onRowsPerPageChange={(e) => handleTopPageSizeChange(e.target.value)}
            component="div"
            rowsPerPageOptions={[
              25,
              50,
              75,
              100,
              250,
              500,
              1000,
              1500,
              2000,
              {
                label: "All",
                value: records?.totalCount
                  ? records?.totalCount
                  : records?.length || 0,
              },
            ]}
          />

          <button className="btnPrimary ml-3 mr-2" onClick={handleNewReport}>
            Create Domain Outreach
          </button>
        </div>
      </GridToolbarContainer>
    );
  }

  const columnDefs = [
    {
      headerName: "Sr#",
      field: "counter",
      filterable: false,
      width: 10,
    },
    {
      headerName: "Domain",
      field: "dor.domain",
      minWidth: 280,
      renderCell: (params) => params.row?.["dor.domain"],
    },
    {
      headerName: "Outreach Source",
      field: "dor.out_reach_source",
      minWidth: 230,
      renderCell: (params) => params.row?.["dor.out_reach_source"],
    },
    {
      field: "dor.created_by",
      headerName: "Created By",
      minWidth: 100,
      type: "singleSelect",
      getOptionValue: (value) => value?.id,
      getOptionLabel: (value) => value.name,
      valueOptions: users,
      valueGetter: (params) => params.row.created_by_name,
      valueFormatter: (params) => params.value,
      renderCell: (params) => <>{params.row.created_by_name || "N/A"}</>,
    },
    {
      field: "dor.verified_by",
      headerName: "Verified By",
      minWidth: 100,
      type: "singleSelect",
      getOptionValue: (value) => value?.id,
      getOptionLabel: (value) => value.name,
      valueOptions: users,
      valueGetter: (params) => params.row.verified_by_name,
      valueFormatter: (params) => params.value,
      renderCell: (params) => <>{params.row.verified_by_name || "N/A"}</>,
    },
    {
      headerName: "Task Status",
      field: "dor.status",
      minWidth: 180,
      sortable: false,
      filter: false,
      disableColumnMenu: true,
      align: "center",
      type: "singleSelect",
      valueGetter: (params) => params.row?.["dor.status"],
      getOptionValue: (option) => option?.value,
      getOptionLabel: (option) => option.label,
      valueOptions: taskStatusOptions,
      renderCell: ({ row }) => {
        const status = row?.["dor.status"];

        const options = [
          { value: "inReview", label: "In Review" },
          { value: "inProcess", label: "In Process" },
          { value: "cancelled", label: "Cancelled" },
          { value: "completed", label: "Completed" },
          { value: "reOpen", label: "Reopen" },
        ];

        const statusClasses = {
          pending: "bg-yellow-100 text-yellow-800",
          inProcess: "bg-blue-100 text-blue-800",
          cancelled: "bg-red-100 text-red-800",
          completed: "bg-green-100 text-green-800",
          reOpen: "bg-indigo-100 text-indigo-800",
        };

        const formatText = (val) =>
          val
            ?.split(/(?=[A-Z])/)
            .map((w) => w[0].toUpperCase() + w.slice(1))
            .join(" ") || "N/A";

        const getOption = (val) =>
          options.find((opt) => opt.value === val) || {
            value: val,
            label: formatText(val),
          };

        const currentStatus = status ? getOption(status) : null;

        // Use only the predefined options
        const dropdownOptions = [...options];

        const handleChange = (e) => {
          const newVal = e?.value;
          if (newVal && newVal !== status) {
            updateStatus(row?.records, newVal, status);
          }
        };

        const itemTemplate = (option) => {
          const cls =
            statusClasses[option?.value] || "bg-gray-100 text-gray-800";
          return (
            <div
              className={`${cls} text-center py-1 px-1 rounded text-xs capitalize`}
            >
              {option?.label || formatText(option?.value)}
            </div>
          );
        };

        const valueTemplate = (option) => {
          const val = option?.value || status;
          const cls = statusClasses[val] || "bg-gray-100 text-gray-800";
          return (
            <div className="w-full h-full flex items-center justify-center !ml-0">
              <span
                className={`${cls} py-1 px-3 rounded-full text-sm font-medium whitespace-nowrap`}
              >
                {formatText(val)}
              </span>
            </div>
          );
        };

        const selected = currentStatus || dropdownOptions[0] || null;

        if (!selected) {
          return (
            <div className="text-center text-xs text-gray-500">No status</div>
          );
        }

        return (
          <div className="w-full flex justify-center">
            <Dropdown
              value={status}
              options={dropdownOptions}
              onChange={handleChange}
              optionLabel="label"
              itemTemplate={itemTemplate}
              valueTemplate={valueTemplate}
              placeholder="Select Status"
              style={{ height: "100%", display: "flex", alignItems: "center" }}
              className="w-full border-none h-full"
              panelClassName="w-36"
              appendTo={document.body}
            />
          </div>
        );
      },
    },
    {
      headerName: "Live URL",
      field: "dor.live_url",
      minWidth: 300,
      renderCell: (params) => (
        <div className="flex items-center">
          <ClipboardDocumentIcon
            onClick={() =>
              handleCopyContent(`${params.row?.["dor.live_url"]}`, "Live URL")
            }
            className="w-5 h-5 cursor-pointer text-blue-500 hover:text-blue-700 mr-2"
            title="Copy URL"
          />
          <span className="mr-2">{params.row?.["dor.live_url"]}</span>
        </div>
      ),
    },
    {
      headerName: "Note",
      field: "dor.note",
      width: 150,
      headerAlign: "center",
      wrap: true,
      align: "center",
      filterable: false,
      cellClassName: "multiline-cell",
    },
    {
      field: "dor.created_at",
      headerName: "Created Date",
      width: 200,
      type: "date",
      valueGetter: (params) => new Date(params.row?.["dor.created_at"]),
      sortComparator: (v1, v2, row1, row2) => {
        const date1 = new Date(row1.value);
        const date2 = new Date(row2.value);
        return date1 - date2;
      },
      renderCell: (params) => {
        const rawDate = params.row?.["dor.created_at"];
        if (rawDate) {
          return dayjs(rawDate).format("ddd, MMM D, YYYY h:mm A");
        }
        return "";
      },
    },
    {
      field: "dor.verified_at",
      headerName: "Verified Date",
      width: 200,
      type: "date",
      valueGetter: (params) => new Date(params.row?.["dor.verified_at"]),
      sortComparator: (v1, v2, row1, row2) => {
        const date1 = new Date(row1.value);
        const date2 = new Date(row2.value);
        return date1 - date2;
      },
      renderCell: (params) => {
        const rawDate = params.row?.["dor.verified_at"];
        if (rawDate) {
          return dayjs(rawDate).format("ddd, MMM D, YYYY h:mm A");
        }
        return "";
      },
    },
    {
      headerName: "Actions",
      field: "actions",
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="relative">
            <div className="flex items-center justify-center">
              <PencilSquareIcon
                key={`${params?.row.username}-action`}
                className="h-5 w-5 cursor-pointer text-black-400"
                onClick={() => handleEditReport(params.row.records)}
                title="Edit Domain Outreach"
              />
              <div
                className="relative ml-1 cursor-pointer"
                onClick={(e) => deleteReport(params.row.records?.["dor.id"])}
              >
                <MdDelete
                  className="h-5 w-5 text-black-400 relative z-10"
                  title="Delete Domain Outreach"
                  size={18}
                />
              </div>
            </div>
          </div>
        );
      },
    },
  ];

  const refreshListing = async () => {
    await get_listing({
      ...paginationModel,
      pageSize: paginationModel.pageSize,
      filters: queryOptions,
    });
  };
  const deleteReport = (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this Domain Outreach?"
    );
    if (!isConfirmed) return;
    api
      .delete(`/api/domains/out_reach/${id}`)
      .then((res) => {
        toast.success("Domain Outreach Removed Successfully.");
        get_listing({
          ...paginationModel,
          pageSize: paginationModel.pageSize,
          filters: queryOptions,
        });
      })
      .catch((err) => toast.error(err.response.data.message));
  };
  const offset = (paginationModel?.page - 1) * paginationModel?.pageSize;

  const getRowHeight = (params) => {
    const rowHeight = 30; // minimum height of the row
    const data = params?.model;
    const substring = data?.["dor.note"]?.substring(0, 100);
    const numberOfLines = substring ? Math.ceil(substring?.length / 30) : 0;
    const addressHeight = rowHeight + numberOfLines * 30 + 0;
    let height = 0;

    return Math.max(rowHeight, addressHeight, height);
  };

  return (
    <div className="px-6 pt-4">
      <CustomBreadcrumbs
        crumbs={[
          { label: "Home", link: "/" },
          { label: "Domain Outreach Report", link: "" },
        ]}
      />
      <ToastContainer />
      {isLoading && <Loading />}
      <div className="bg-white my-3 border rounded">
        <MUIDataTable
          columnDefs={columnDefs}
          items={records?.data?.map((data, index) => {
            const counter = offset + index + 1;
            const {
              "dor.id": id,
              "dor.domain": domain,
              "dor.out_reach_source": out_reach_source,
              "dor.live_url": live_url,
              created_by_name,
              "dor.status": status,
              "dor.note": note,
              verified_by_name,
              "dor.created_by": created_by,
              "dor.created_at": created_at,
              "dor.verified_at": verified_at,
            } = data;
            return {
              records: data,
              counter,
              "dor.id": id,
              "dor.domain": domain,
              "dor.out_reach_source": out_reach_source,
              "dor.live_url": live_url,
              "dor.note": note || "N/A",
              created_by_name,
              "dor.created_by": created_by,
              "dor.status": status,
              verified_by_name,
              "dor.created_at": created_at || null,
              "dor.verified_at": verified_at || null,
            };
          })}
          totalItems={records?.totalCount}
          paginationModel={paginationModel}
          CustomToolbar={CustomToolbar}
          height="88vh"
          searchable="No"
          showCount="No"
          onPaginationModelChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          onFilterModelChange={onFilterChange}
          gridOptions={getRowHeight}
          sx={{
            [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]:
              {
                outline: "none",
              },
            [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
              {
                outline: "none",
              },
          }}
        />
      </div>

      <Modal
        open={!modalState.open}
        handleModal={() => handleModal(modalState.data)}
        cancelButtonRef={cancelButtonRef}
        className="max-w-2xl"
        title={
          modalState.data ? "Edit Domain Outreach" : "Create Domain Outreach"
        }
      >
        <AddUpdateForm
          handleModal={() => handleModal(modalState.data)}
          fetchData={refreshListing}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          isEditMode={!!modalState.data}
          records={modalState.data || {}}
        />
      </Modal>
      {isReasonModal ? (
        <UpdateReason
          onClose={() => {
            setReasonModal(false);
            setStatusNote("");
            setHoldReason([]);
          }}
          updateStatus={performStatusUpdate}
          taskObj={isTaskStatus}
          setStatusNote={setStatusNote}
          isStatusNote={isStatusNote}
          errors={errors}
          setHoldReason={setHoldReason}
          isHoldReason={isHoldReason}
        />
      ) : null}
    </div>
  );
}
